<template>
    <div class="item-loader text-xs-center">
      <m-camera ref="camera"></m-camera>
      <div class="justify-center text-xs-center" style="width:100%">
      <span v-if="!uploading">
          <v-btn fab large dark color="primary" @click="onShowCamera">
            <v-icon>camera_alt</v-icon>
          </v-btn>

        <m-upload-btn :id="1" :selectedCallback="photoUpload"></m-upload-btn>
      </span>
      <span  v-if="uploading" class="pa-1">
        <v-progress-circular
          :size="70"
          :width="5"
          :rotate="-90"
          :value="progressUpload"
          color="primary"
        >
          {{ progressUpload }}
        </v-progress-circular>
      </span>
      </div>
      <div v-if="imageUrl" class="justify-center text-xs-center pt-2" style="width:100%">
        <img :src="imageUrl" height="72px"/>
      </div>


  </div>

</template>

<script>
  import moment from 'moment';
  import { database, storage } from '@/services/firebase';
  import MCamera from '@/components/uploader/camera';
  import MUploadBtn from '@/components/uploader/uploadBtn';

  export default {
    name: 'ticketUploader',
    props: ['itemId', 'form'],
    components: {
      'm-camera': MCamera,
      'm-upload-btn': MUploadBtn
    },
    data () {
      return {
        uploading: false,
        itemObj: {},
        imageUrl: null,
        contentType: null,
        progressUpload: 0,
        uploadTask: null
      }
    },
    methods: {
      close () {
        this.$emit('close');
      },
      onShowCamera () {
        var itemId = this.itemId;
        this.camera = true;
        this.progressUpload = 0;
        this.$refs.camera.open(itemId).then((image) => {
          if (image) {
            console.log('camera confirmed');
            this.photoUpload(image);
          }
        });
      },
      photoUpload (image) {
        var app = this;
        this.progressUpload = 0;
        app.imageUrl = null;
        app.uploading = true;
        app.itemObj = {};

        this.create(image, function (result) {
          console.log('createTicket response', result);
          app.itemObj = result;
          setTimeout(() => {
            app.uploading = false;
            app.imageUrl = app.itemObj.imageUrl
            app.contentType = result.type
            app.$emit('uploaded', result);
          }, 250)
        })
      },
      create (image, callbback) {
        var app = this;
        var itemId = 1; // this.itemId;
        const item = {
          date: moment().format('YYYY-MM-DD'),
          id: itemId
        }
        var imageUrl
        var key
        var contentType
        var dbref = database.ref('expense');

        console.log(dbref);

        dbref.orderByChild('id').equalTo(itemId).once('value', snapshot => {
          // let updates = {};
          snapshot.forEach((child) => {
            dbref.child(child.key).remove();
            storage.ref('expense/' + child.key).delete();
            // console.log(child.setValue(null))
          });
          dbref.push(item)
            .then((data) => {
              key = data.key
              return key
            })
            .then(key => {
              // const filename = image.name
              // const ext = filename.slice(filename.lastIndexOf('.'))
              this.uploadTask = storage.ref('expense/' + key).put(image);
              this.uploadTask.on('state_changed', sp => {
                this.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100)
              })
              return this.uploadTask
            })
            .then(fileData => {
              console.log('fileData: ', fileData);
              contentType = fileData.metadata.contentType;
              return app.uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                dbref.child(key).update({imageUrl: downloadURL, ticketId: key, contentType: contentType})
                console.log('File available at', downloadURL);
                imageUrl = downloadURL
              });
            })
            .then(() => {
              callbback({
                ...item,
                imageUrl: imageUrl,
                contentType: contentType,
                id: key
              })
            })
            .catch((error) => {
              app.uploading = false;
              console.log(error)
            })
        });
      },
      prefill () {
        // var app = this;
      },
      init (v) {
        if (v) {
          this.prefill();
        }
      }
    },
    watch: {
      dialog (value) {
        this.init(value);
      }
    },
    created () {
      // this.getData()
    },
    filters: {
    }
  }
</script>
<style lang="scss">
  .item-loader {
    position: relative;
    width: 100%;
    img {
      padding: 5px;
      border: solid 1px grey;
      border-radius: 4px;
    }

  }
</style>
